const data = {
  api: "http://122.155.13.119:5200"
};

export default data;


// WEBPACK FOOTER //
// ./src/config.js